import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="profile-switcher"
export default class extends Controller {
  static targets = ['menu'];
  static values = {
    profilesCount: Number,
  };

  initialize() {
    this.menuIsOpen = false;
  }

  connect() {}

  handleClick(event) {
    event.preventDefault();
    event.stopPropagation();
    const noOtherProfilesToSwitchTo = this.profilesCountValue < 1;
    if (noOtherProfilesToSwitchTo) {
      return;
    }

    this.menuIsOpen ? this.closeMenu() : this.openMenu();
  }

  openMenu() {
    const { menuTarget } = this;
    menuTarget.classList.remove('h-0', 'opacity-0');
    menuTarget.classList.add('opacity-100', 'h-full');
    this.menuIsOpen = true;
  }

  closeMenu() {
    const { menuTarget } = this;
    menuTarget.classList.remove('h-full', 'opacity-100');
    menuTarget.classList.add('h-0', 'opacity-0');
    this.menuIsOpen = false;
  }
}
